import { render, staticRenderFns } from "./VideoHeader.vue?vue&type=template&id=1e928fa0&scoped=true&"
import script from "./VideoHeader.vue?vue&type=script&lang=ts&"
export * from "./VideoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VideoHeader.vue?vue&type=style&index=0&id=1e928fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e928fa0",
  null
  
)

export default component.exports